module.exports = __webpack_public_path__ + "img/bingo_ball-46.68affc83.png";